// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation[data-v-4740f91b]{display:flex;flex:1;justify-content:flex-end;margin-right:32px}.nav-container[data-v-4740f91b]{display:grid;grid-auto-flow:column;grid-column-gap:32px;list-style:none;margin:0;padding:0}.nav-container>li[data-v-4740f91b]{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
